import React from "react";

export default function PopoverMenuItemDepricated(props:any) {

    const classes = Classes('option',props.className, {
        'with-icon': props.icon || props.emptyIcon,
        'disabled': props.disabled
    });

    return (
        <div className={classes} onClick={!props.disabled ? props.onClick : null}>
            {(props.icon || props.emptyIcon) && <div className={Classes('ico', props.icon)}/>}
            <div className="label">{props.label}</div>
        </div>
    )
}
